import qs from 'qs';

import http from 'api/http';
import { userAPI } from 'api/requests';

import config from 'config';
import { consoleError } from 'utils';

import {
  USER_SIGN_IN_ERROR,
  USER_SIGN_IN_REQUEST,
  USER_SIGN_IN_SUCCESS,
  USER_LOG_OUT_ERROR,
  USER_LOG_OUT_REQUEST,
  USER_LOG_OUT_SUCCESS,
  MENU_CHANGED,
  SELECT_MANUFACTURER,
  SELECT_INSPECTOR,
  UPDATE_MANUFACTURER,
  USER_SAVE_URL,
  USER_CLEAR_URL,
  SELECT_YEAR
} from '../actionTypes';

export function signIn({ accessToken }, mnfCode) {
  return dispatch => {
    dispatch({ type: USER_SIGN_IN_REQUEST });

    const infoUrl = mnfCode ? `${userAPI.info}?mnfCode=${encodeURIComponent(mnfCode)}` : userAPI.info;

    return http
      .get(infoUrl, { headers: { Authorization: `Bearer ${accessToken}` } })
      .then(({ data }) =>
        dispatch({
          type: USER_SIGN_IN_SUCCESS,
          payload: { ...data, token: accessToken },
        })
      )
      .catch(error =>
        dispatch({
          type: USER_SIGN_IN_ERROR,
          payload: error,
        })
      );
  };
}

export function logOut() {
  return dispatch => {
    dispatch({
      type: USER_LOG_OUT_REQUEST
    });

    dispatch({
          type: USER_LOG_OUT_SUCCESS
        });
        window.sessionStorage.clear();

    /* http.post(userAPI.revoke)
      .then(() => {
        dispatch({
          type: USER_LOG_OUT_SUCCESS
        });
        window.sessionStorage.clear();
      })
      .catch((error) => {
        consoleError(error);
        dispatch({
          type: USER_LOG_OUT_ERROR
        });
      }); */
  };
}

export function changeMenu(role) {
  return {
    type: MENU_CHANGED,
    payload: role
  };
}

export function selectManufacturer(manufacturer) {
  return {
    type: SELECT_MANUFACTURER,
    payload: manufacturer
  };
}

export function selectInspector(inspector) {
  return {
    type: SELECT_INSPECTOR,
    payload: inspector
  };
}

export function updateManufacturer(manufacturer) {
  return {
    type: UPDATE_MANUFACTURER,
    payload: manufacturer
  };
}

export function storeSelectedYear (role, year) {
  return {
    type: SELECT_YEAR,
    payload: {role:[role], year:year}
  }
}

export function saveUrlToRedirect(url) {
  return dispatch => {
    dispatch({
      type: USER_SAVE_URL,
      payload: url
    });
  };
}

export function clearUrlToRedirect(id) {
  return dispatch => {
    dispatch({
      type: USER_CLEAR_URL,
      payload: id
    });
  };
}



// WEBPACK FOOTER //
// ./src/app/store/actions/user.js